const containsText = (text, item) => {
  const lowerCasedText = text?.trim().toLowerCase();
  return item?.toLowerCase().includes(lowerCasedText);
};

export const filterData = (text, dataArray, extraFilters = []) => {
  return dataArray?.filter(
    (item) =>
      containsText(text, item?.user_name) ||
      containsText(text, item?.phone_number) ||
      containsText(text, item?.user_phone) ||
      containsText(text, item?.address) ||
      containsText(text, item?.cx_formatted_address) ||
      extraFilters.some((extraFilter) => extraFilter(item, text)),
  );
};

export const searchAndFilterData = (
  text,
  data,
  extraFilters = [
    // eslint-disable-next-line no-shadow
    (item, text) =>
      item?.orders_list?.find((order) =>
        order?.toLowerCase().includes(text?.trim().toLowerCase()),
      ),
  ],
) => {
  return {
    ...data,
    usersDelivered: filterData(text, data?.usersDelivered, extraFilters),
    usersToBeDelivered: filterData(
      text,
      data?.usersToBeDelivered,
      extraFilters,
    ),
    usersToBeDeliveredFirstTime: filterData(
      text,
      data?.usersToBeDeliveredFirstTime,
      extraFilters,
    ),
    usersUnableToDeliver: filterData(
      text,
      data?.usersUnableToDeliver,
      extraFilters,
    ),
  };
};
